import { AbgSxProps, Brand } from '@abg/typings';

import { FIELD_STYLES } from '../../../organisms/BookingWidget/booking-widget.styles';

export const pickerFooterContainerStyles: AbgSxProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '16px',
  minHeight: '76px',
  background: {
    xs: '#fff',
    md: 'unset',
  },
  boxShadow: {
    xs: '0px -2px 10px 0px rgba(0, 0, 0, 0.06)',
    md: 'none',
  },
};

export const doneButtonContainerStyles: AbgSxProps = {
  display: 'flex',
  alignItems: 'center',
  gap: '24px',
};

export const buttonCancelStyles: AbgSxProps = {
  color: '#000',
  boxShadow: 'none !important'
};

export const buttonDoneStyles = (brand: Brand) => ({
  borderRadius: FIELD_STYLES[brand].borderRadius,
});
